import '../styles/Header.css';
import PropTypes from 'prop-types';

function Header({logo}) {
  return (
    <header className="header">
      <nav className="navbar">
        <ul className="menu">
          <li><span></span></li>
          <li><span></span></li>
          <li><span></span></li>
          <li><span></span></li>
        </ul>
          <div className="logo-header">another<br />photo<br />guy</div>
      </nav>

      <div className="hero-section">
        <div className="hero-content">
          {logo && <img src={logo} alt="Logo" className="logo" />}
          <h1 className="coming-soon-title">coming soon</h1>
          <p className="subtitle">I'm working on something... <br />Don't know what yet, but something...</p>
        </div>
      </div>
    </header>
  );
}

Header.propTypes = {
    logo: PropTypes.string,
};


export default Header;

